import './sectionCharacters.scss';
export default (() => {
	var $owl = $('.characters__slider.owl-carousel');
	$owl.children().each(function (index) {
		$(this).attr('data-position', index); // NB: .attr() instead of .data()
	});

	$(document).ready(function () {
		$('.characters__slider').owlCarousel({
			items: 1,
			loop: true,
			center: true,
			margin: -50,
			dots: true,
			stagePadding: 40,
			nav: false,
			responsive: {
				480: {
					stagePadding: 60
				},
				768: {
					items: 3,
					margin: 40,
					stagePadding: 0
				},
				992: {
					items: 3,
					margin: 80,
					stagePadding: 0
				}
			}
		});

		$(document).on('click', '.owl-item>div', function () {
			$owl.trigger('to.owl.carousel', $(this).data('position'));
		});
	});
})();
